export const ChevronIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99992 4.79297L8.58571 6.20718L14.3786 12.0001L8.58571 17.793L9.99992 19.2072L17.207 12.0001L9.99992 4.79297Z"
      fill="currentColor"
    />
  </svg>
);
